import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const MedicalCredentialsForm = ({ formData, errors, onChange, onSelectChange }) => {
  const specialtyOptions = [
    { value: 'radiology', label: 'Radiology' },
    { value: 'emergency', label: 'Emergency Medicine' },
    { value: 'general', label: 'General Practice' },
    { value: 'cardiology', label: 'Cardiology' },
    { value: 'orthopedics', label: 'Orthopedics' },
    { value: 'neurology', label: 'Neurology' },
    { value: 'oncology', label: 'Oncology' },
    { value: 'pediatrics', label: 'Pediatrics' },
    { value: 'surgery', label: 'Surgery' },
    { value: 'internal', label: 'Internal Medicine' }
  ];

  const licenseTypeOptions = [
    { value: 'md', label: 'MD - Doctor of Medicine' },
    { value: 'do', label: 'DO - Doctor of Osteopathic Medicine' },
    { value: 'mbbs', label: 'MBBS - Bachelor of Medicine, Bachelor of Surgery' },
    { value: 'resident', label: 'Medical Resident' },
    { value: 'fellow', label: 'Medical Fellow' }
  ];

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="FileText" size={18} className="sm:w-5 sm:h-5" color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base sm:text-lg font-semibold text-foreground truncate">Medical Credentials</h3>
          <p className="text-xs sm:text-sm text-muted-foreground">Provide your professional information</p>
        </div>
      </div>

      <div className="space-y-3 sm:space-y-4">
        <Select
          label="License Type"
          options={licenseTypeOptions}
          value={formData?.licenseType}
          onChange={(value) => onSelectChange('licenseType', value)}
          error={errors?.licenseType}
          placeholder="Select your medical license type"
          required
        />

        <Input
          label="Medical License Number"
          type="text"
          name="licenseNumber"
          placeholder="e.g., MD123456"
          description="Enter your state/national medical license number"
          value={formData?.licenseNumber}
          onChange={onChange}
          error={errors?.licenseNumber}
          required
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="License Issuing State/Country"
            type="text"
            name="licenseState"
            placeholder="e.g., California, USA"
            value={formData?.licenseState}
            onChange={onChange}
            error={errors?.licenseState}
            required
          />

          <Input
            label="License Expiry Date"
            type="date"
            name="licenseExpiry"
            value={formData?.licenseExpiry}
            onChange={onChange}
            error={errors?.licenseExpiry}
            required
          />
        </div>

        <Select
          label="Medical Specialty"
          options={specialtyOptions}
          value={formData?.specialty}
          onChange={(value) => onSelectChange('specialty', value)}
          error={errors?.specialty}
          placeholder="Select your primary specialty"
          searchable
          required
        />

        <Input
          label="Institution/Hospital Name"
          type="text"
          name="institution"
          placeholder="e.g., Johns Hopkins Hospital"
          description="Your primary place of practice"
          value={formData?.institution}
          onChange={onChange}
          error={errors?.institution}
          required
        />

        <Input
          label="Years of Practice"
          type="number"
          name="yearsOfPractice"
          placeholder="0"
          min="0"
          max="60"
          value={formData?.yearsOfPractice}
          onChange={onChange}
          error={errors?.yearsOfPractice}
          required
        />
      </div>
    </div>
  );
};

export default MedicalCredentialsForm;